export interface WizardFormData {
  // Step 1: Basic Info
  name: string;
  slug: string;

  // Step 2: Admin Account
  adminName: string;
  adminEmail: string;

  // Step 3: Plan (stores the plan ID from API)
  planId: string;

  // Step 4: Branding
  branding: {
    logoUrl?: string;
    logoFileId?: string;
    primaryColor?: string;
    secondaryColor?: string;
  };

  // Step 5: Settings
  settings: {
    timezone: string;
    language: string;
    currency: string;
  };
}

export const initialFormData: WizardFormData = {
  name: '',
  slug: '',
  adminName: '',
  adminEmail: '',
  planId: '',
  branding: {
    logoUrl: '',
    primaryColor: '#4F46E5',
    secondaryColor: '#818CF8',
  },
  settings: {
    timezone: 'America/Mexico_City',
    language: 'es',
    currency: 'MXN',
  },
};

export interface StepProps {
  formData: WizardFormData;
  onChange: (data: Partial<WizardFormData>) => void;
  onValidChange: (isValid: boolean) => void;
  errors: Record<string, string>;
}
